<template>
  <div>
    <div
      id="arztsuche_map"
      class="arztsuche_map"
      ref="mapholder"
      data-html2canvas-ignore
    ></div>
    <div
      v-for="(item, i) in pagedLocs"
      :ref="
        (el) => {
          if (el) divs[i] = el;
        }
      "
      class="infobubble"
      data-html2canvas-ignore
    >
      <Result :loc="item" />
    </div>
  </div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet.markercluster/dist/leaflet.markercluster";

import appConf from "@/config/config.js";
import Result from "@/components/Result";
import _fireEventOnMarkerOrVisibleParentCluster from "@/composables/markerFuncs";

import {
  onMounted,
  watchEffect,
  ref,
  watch,
  h,
  resolveComponent,
  onBeforeUpdate,
  onUpdated,
} from "vue";

export default {
  components: { Result },
  props: ["pagedLocs", "selectedLoc", "printing"],
  setup(props, { emit }) {
    const locs = ref(props.pagedLocs);
    const locIn = ref(null);
    const map = ref();
    const result = ref(null);
    const selectedLoc = ref(null);
    const markersAr = ref([]);
    const markers = ref(null);
    const mapholder = ref(null);
    const divs = ref([]);
    let isNewPage = false;
    let markersLayer;

    onBeforeUpdate(() => {
      divs.value = [];
    });

    onMounted(() => {
      map.value = L.map(mapholder.value).setView([52.5219, 13.38], 9);
      markersLayer = L.layerGroup().addTo(map.value);
      markers.value = L.markerClusterGroup();

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors. Base map and data from OpenStreetMap and OpenStreetMap Foundation',
      }).addTo(map.value);
    });

    const placeMarkers = () => {
      if (props.pagedLocs.length) {
        markers.value.clearLayers();
        let boundsAr = [];
        let pointsAr = [];
        markersAr.value = [];

        props.pagedLocs.forEach((locUp, i) => {
          locIn.value = locUp;
          let point = [locUp.lat, locUp.lon];
          pointsAr.push(point);
          boundsAr.push(point);
          let markerFile = i < 10 ? i + 1 : 10;

          let markerUrl = `/typo3conf/ext/arztsuchevue/Resources/Public/Images/Markers/${markerFile}.svg`;
          let iconUp = L.icon({
            iconUrl: markerUrl,
          });
          let marker = L.marker(point, { icon: iconUp });
          marker.id = locUp.id;
          markers.value.addLayer(marker);
          markersAr.value[locUp.id] = marker;
          let infobubble = divs.value[i];
          marker.bindPopup(infobubble);
        });

        if (boundsAr.length) {
          map.value.addLayer(markers.value);
          map.value.fitBounds(boundsAr, { padding: [50, 50] });
        }

        markersAr.value.forEach((markerUp) => {
          markerUp.addEventListener("click", (event) => {
            event.target.openPopup();
            map.value.setView([
              markerUp._latlng.lat + 0.0001,
              markerUp._latlng.lng,
            ]);
            selectedLoc.value = markerUp.id;
            emit("select-loc", markerUp.id);
          });
          markerUp.getPopup().addEventListener("remove", (event) => {
            emit("select-loc", null);
          });
        });
      }
    };

    const selectLoc = (id) => {
      selectedLoc.value = id;
      emit("select-loc", id);
    };

    onUpdated(() => {
      if (!props.printing && isNewPage) {
        placeMarkers();
        isNewPage = false;
      }
    });

    // watch(
    //   () => props.pagedLocs,
    //   (val, prevVal) => {
    // if (!props.printing) {
    //   placeMarkers();
    // }
    //   }
    // );
    watch(
      () => props.pagedLocs,
      (val, prevVal) => {
        if (val !== prevVal) {
          isNewPage = true;
        }
      }
    );

    watch(
      () => props.selectedLoc,
      (val, prevVal) => {
        if (val) {
          selectedLoc.value = val;
          if (map.value.hasLayer(markersAr.value[val])) {
            markersAr.value[val].fire("click");
          } else {
            _fireEventOnMarkerOrVisibleParentCluster(
              markersAr.value[val],
              markers.value,
              "click"
            );
            markersAr.value[val].fire("click");
          }
        }
      }
    );

    return { locs, locIn, result, selectLoc, markersAr, mapholder, divs };
  },
};
</script>

<style>
</style>